// extracted by mini-css-extract-plugin
export var active = "_39-7";
export var container = "_39-0";
export var evenWidth = "_39-4";
export var large = "_39-5";
export var outlet = "_39-8";
export var slide = "_39-2";
export var small = "_39-6";
export var tab = "_39-3";
export var tabs = "_39-1";